module.exports = __webpack_public_path__ + "static/media/icon3.ffb95f37.svg";